import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface FileUploadIconProps {
  size?: number;
  color?: string;
}

const FileUploadIcon: React.FC<FileUploadIconProps> = ({
  size = 24,
  color = '#1434CB',
}) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default FileUploadIcon;
